import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from "@angular/core";
import { NoticeEntity } from "@youm-front/notice/domain";

@Component({
  selector: "app-notice-ui-notice-list-item",
  templateUrl: "./notice-list-item.component.html",
  styleUrls: ["./notice-list-item.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoticeListItemComponent {
  @Input() notice!: NoticeEntity;

  @Output() delete = new EventEmitter<NoticeEntity>();

  onDelete() {
    this.delete.emit(this.notice);
  }
}
